import React from 'react';
import { Link } from 'react-router-dom';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = () => {
  const dataColumns = [
    {
      field: 'rn',
      title: 'RN',
      editable: false,
      show: false,
      width: '30px',
      minResizableWidth: 150,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'bug_id',
      title: 'BUG#',
      editable: false,
      show: true,
      width: '100px',
      minResizableWidth: 250,
      filterable: true,
      className: 'grid-cells',
      cell: (props) => (
        <td className="link-column">
          <>
            <Link to={props.dataItem.bug_url} target="_blank">
              {props.dataItem.bug_id}
            </Link>
          </>
        </td>
      ),
    },
    {
      field: 'file_path',
      title: 'File Name',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      filterable: true,
      cell: (props) => (
        <td className="link-column">
          <>
            <Link to={props.dataItem.file_url} target="_blank">
              {props.dataItem.file_path}
            </Link>
          </>
        </td>
      ),
    },
    {
      field: 'rollout',
      title: 'Rollout',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 250,
      filterable: true,
      className: 'grid-cells',
    },
    {
      field: 'commit_date',
      title: 'Data/Time',
      editable: false,
      show: true,
      width: '100px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'author',
      title: 'Author',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'action',
      title: 'Action',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
  ];

  return dataColumns;
};
export default DataColumns;
